/**
 * @author Kelnik
 *
 * FullIframe - открытие ссылки в iframe
 */

import tmplIframe from './template/iframe.twig';
import {Utils} from 'common/scripts/utils';

class FullIframe {
    constructor(options) {
        this.target = options.target;
        this.planoplan = 'planoplan' in this.target.dataset;
    }

    init() {
        if (!this.target) {
            return;
        }

        this._bindEvents();
    }

    _bindEvents() {
        this.target.addEventListener('click', this._clickTarget.bind(this));
    }

    _clickTarget(event) {
        event.preventDefault();

        this._insertIframe();
        this._bindEventsAfterOpen();
    }

    _insertIframe() {
        Utils.bodyFixed();
        this.container = document.createElement('div');

        document.body.insertAdjacentElement('beforeend', this.container);
        if (this.planoplan) {
            this.container.insertAdjacentHTML('afterbegin', tmplIframe());

            /* eslint-disable no-undef */
            Planoplan.init({
                uid         : `${this.target.dataset.planoplan}`,
                el          : 'widget',
                primaryColor: '#b98f4f'
            });
            /* eslint-enable no-undef */
        } else {
            this.container.insertAdjacentHTML('afterbegin', tmplIframe({href: this.target.href}));
        }
    }

    _bindEventsAfterOpen() {
        const closes = Array.from(this.container.querySelectorAll('.j-fill-iframe__close'));

        closes.forEach((close) => {
            close.addEventListener('click', () => {
                this._remove();
            });
        });
    }

    _remove() {
        Utils.removeElement(this.container);
        Utils.bodyStatic();
    }
}

export default FullIframe;
